import { get, patch, post, deleteRequest } from "../../utils/api";

export const adminApi = {
    roleCreate: (data) => post(`/admin/user-role`, data),
    roleList: () => get(`/admin/user-role`),
    roleUpdate: (data) => { const { id, ...rest } = data; return patch(`/admin/user-role/${id}`, rest); },
    roleDelete: (data) => deleteRequest(`/admin/user-role/${data.id}`),
    adminDashboardCount: () => get(`/admin/dashboard/count`),
    auditLogs: (data = {}) => {
        const search = data?.search || "";
        const page = data?.page || 1;
        const limit = data?.limit || 10;

        const params = new URLSearchParams({
            search,
            page: String(page),
            limit: String(limit),
        });

        return get(`/admin/audit-logs?${params.toString()}`);
    },
    getItemById: (data) => get(`/admin/items/${data.id}`),
    getAdminPayments: (data = {}) => {
        const search = data?.search || "";
        const page = data?.page || 1;
        const limit = data?.limit || 10;
        const status = data?.status || "all";

        const params = new URLSearchParams({
            search,
            status,
            page: String(page),
            limit: String(limit),
        });

        return get(`/admin/payments?${params.toString()}`);
    },
    getPaymentTechnicalLogs: (paymentId) => get(`/admin/payments/${paymentId}/logs`),
};
